import { ApplicationConfig, provideZoneChangeDetection, APP_INITIALIZER } from '@angular/core';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './core/auth.interceptor';
import { AuthService } from './services/auth/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => {
        return () => auth.init().then((authenticated) => {
          // If not authenticated after init, force a login redirect to Keycloak
          if (!authenticated) {
            try {
              console.warn('SSO init returned unauthenticated — redirecting to login.');
              auth.login();
            } catch (e) {
              console.error('Error while forcing SSO login after failed init:', e);
            }
          }
          return Promise.resolve(authenticated);
        }).catch((err) => {
          // Initialization failed due to network or configuration — force login attempt
          console.error('SSO initialization failed during APP_INITIALIZER:', err);
          try { auth.login(); } catch (e) { console.error('login failed:', e); }
          // Return a resolved promise so bootstrap can continue while login redirect occurs
          return Promise.resolve(false);
        });
      },
      deps: [AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true // Indique qu'il peut y avoir plusieurs intercepteurs
    },
    providePrimeNG({
      theme: {
        preset: 'aura',
        options: {
          cssLayer: {
            name: 'primeng',
            order: 'tailwind-utilities, tailwind-base, primeng, '
          }
        }
      }
    })
  ]
};
